import React from 'react';
import { Button } from "antd";
import { ButtonProps } from 'antd/es/button';
import styled from "styled-components";
import styles from "src/styles";

const GhostButton = ({ children, ...props }: ButtonProps) => {
    return (
        <ButtonStyled {...props} ghost>
            {children}
        </ButtonStyled>
    );
};

const ButtonStyled = styled(Button)`
    &.ant-btn.ant-btn-background-ghost {
        &:focus {
            color: ${styles.fontColorWhite};
            border-color: ${styles.fontColorWhite};
        }

        &:hover {
            background: ${styles.fontColorWhite};
            border: 1px solid ${styles.fontColorWhite};
            box-sizing: border-box;
            border-radius: 2px;
            color: ${styles.fontColorBlack};
        }
    }
`;

export default GhostButton;